import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { PORTFOLIO } from '../constants/portfolio';
import '../styles/Footer.scss';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          <div>
            <p className="footer__brand">Sai Bhargav<span>.</span></p>
            <p className="footer__tagline">{PORTFOLIO.tagline}</p>
          </div>
          <div className="footer__links">
            <Link to="/">Home</Link>
            <Link to="/blog">Blog</Link>
            <a href={PORTFOLIO.resume} download>Resume</a>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {year} {PORTFOLIO.name}. Made with <FaHeart className="footer__heart" /> in India</p>
          <div className="footer__social">
            <a href={PORTFOLIO.social.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href={PORTFOLIO.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href={PORTFOLIO.social.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
